import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";

const ExternalRedirectPage = () => {
  return (
    <PageContainer>
      <ContentBox
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Title>외부 브라우저로 이동되었습니다</Title>
        <IconContainer>
          <Icon>✓</Icon>
        </IconContainer>
        <Description>
          앱 내 브라우저에서는 일부 기능이 제한되어
          <br />
          외부 브라우저로 이동되었습니다.
          <br />
          <br />
          외부 브라우저가 열리지 않았다면,
          <br />
          아래 링크를 클릭하세요.
        </Description>
        <OpenBrowserButton
          onClick={() => {
            const originalUrl =
              sessionStorage.getItem("originalUrl") || window.location.origin;
            // 카카오톡 인앱 브라우저에서는 특별한 URL 스키마 사용
            if (navigator.userAgent.indexOf("KAKAOTALK") > -1) {
              window.location.href = `kakaotalk://web/openExternal?url=${encodeURIComponent(
                originalUrl
              )}`;
            }
            // 안드로이드 기기의 다른 인앱 브라우저
            else if (/android/i.test(navigator.userAgent)) {
              window.location.href = `intent://${window.location.host}${window.location.pathname}${window.location.search}#Intent;scheme=https;package=com.android.chrome;end`;
            }
            // iOS 기기의 다른 인앱 브라우저
            else if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
              window.location.href = originalUrl;
            }
            // 그 외 플랫폼
            else {
              window.location.href = originalUrl;
            }
          }}
        >
          외부 브라우저로 열기
        </OpenBrowserButton>
      </ContentBox>
    </PageContainer>
  );
};

const PageContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f8f8f8;
  padding: 20px;
`;

const ContentBox = styled(motion.div)`
  max-width: 400px;
  width: 100%;
  background-color: #f8f8f8;
  border-radius: 20px;
  padding: 30px 20px;
  text-align: center;
`;

const Title = styled.h1`
  font-size: 22px;
  font-weight: 700;
  color: #333;
  margin-bottom: 20px;
`;

const IconContainer = styled.div`
  margin: 20px 0;
`;

const Icon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  background-color: #e6f7e6;
  border-radius: 50%;
  margin: 0 auto;
  font-size: 30px;
  color: #4caf50;
`;

const Description = styled.p`
  font-size: 16px;
  line-height: 1.6;
  color: #666;
  margin-bottom: 30px;
`;

const OpenBrowserButton = styled.button`
  background-color: #0075ff;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: #0066dd;
  }
`;

export default ExternalRedirectPage;
